import { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeStyles } from '../styles/Theme/ThemeStyles';
import { BrowserRouter } from 'react-router-dom';
import LoadingScreen from '../components/shared/loading/LoadingScreen';
import { ThemeProvider } from '@mui/material';
import { TypographyProvider } from '../context/TypographyContext';

// Initialize React Query Client
const queryClient = new QueryClient();

const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <ThemeProvider theme={ThemeStyles}>
                <TypographyProvider>
                    <QueryClientProvider client={queryClient}>
                        <BrowserRouter>
                            {children}
                        </BrowserRouter>
                    </QueryClientProvider>
                </TypographyProvider>
            </ThemeProvider>
        </Suspense>
    );
};

export default AppProvider;
